import { createStore, applyMiddleware, compose } from 'redux';
import Thunk from 'redux-thunk';
import reducers from '../reducers';

const DEBUG = import.meta.env.DEV;

export function configureStore(initialState) {
  const composeEnhancers = DEBUG ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;
  const store = createStore(reducers, initialState, composeEnhancers(applyMiddleware(Thunk)));

  return store;
}
